import * as React from 'react'
import moment from 'moment'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import { Modal, Input, Select, Button, message } from 'antd'
import { API, IInventoryAuditResponse } from '@getgreenline/homi-shared'
import { Track } from '../../../../../../Track'
import { parseErrorMsg } from '../../../../../../utilities/helpers'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  onSubmit: (inventoryAudit: IInventoryAuditResponse) => void
  onClose: () => void
}

interface State {
  title: string
  locationId: number | undefined
  isSaving: boolean
}

@inject('currentCompanyStore')
@observer
export class CreateAuditModal extends React.Component<Props, State> {
  companyId = this.props.currentCompanyStore!.company!.id

  constructor(props: Props) {
    super(props)

    this.state = {
      title: `Audit ${moment().format('MMM D, YYYY')}`,
      locationId: undefined,
      isSaving: false,
    }
  }

  save = async () => {
    const { locationId } = this.state

    if (!this.trimmedAuditTitle || locationId === undefined) {
      return
    }

    this.setState({ isSaving: true })
    try {
      const auditResponse = await API.createInventoryAudit(this.companyId, {
        title: this.trimmedAuditTitle,
        companyId: this.companyId,
        locationId,
        notes: null,
      })

      Track.track('dashboard:audits_created', auditResponse)

      this.props.onSubmit(auditResponse)

      this.setState({ isSaving: false })
    } catch (error) {
      message.error(parseErrorMsg(error) || 'An error occurred while creating an audit')
    } finally {
      this.setState({ isSaving: false })
    }
  }

  get trimmedAuditTitle(): string {
    return this.state.title.trim()
  }

  get isSaveDisabled(): boolean {
    return !this.trimmedAuditTitle || this.state.locationId === undefined
  }

  get saveButtonTitle(): string {
    let title = 'Save'

    if (this.trimmedAuditTitle === '') {
      title = 'Title required'
    } else if (this.state.locationId === undefined) {
      title = 'Location required'
    }

    return title
  }

  render() {
    const locations = this.props.currentCompanyStore!.locations || []

    const { title, locationId } = this.state

    return (
      <Modal
        title='Create an audit'
        visible={true}
        onCancel={() => this.props.onClose()}
        footer={[
          <Button key='cancel' onClick={() => this.props.onClose()}>
            Cancel
          </Button>,
          <Button
            key='btnSave'
            type='primary'
            loading={this.state.isSaving}
            disabled={this.isSaveDisabled}
            onClick={this.save}
          >
            {this.saveButtonTitle}
          </Button>,
        ]}
      >
        <div>
          <label>
            Title <span className='text-danger'>*</span>
          </label>
          <Input value={title} onChange={(e) => this.setState({ title: e.target.value })} />

          <br />
          <br />

          <label>
            Location <span className='text-danger'>*</span>
          </label>
          <div>
            <Select<number>
              value={locationId}
              style={{ width: '100%' }}
              placeholder='Select location'
              allowClear={false}
              onChange={(locationId) => this.setState({ locationId })}
            >
              {locations.map((location, index) => {
                return (
                  <Select.Option
                    key={`audit_modal_location_${location}_${index}`}
                    value={location.id}
                  >
                    {location.name}
                  </Select.Option>
                )
              })}
            </Select>
          </div>
        </div>
      </Modal>
    )
  }
}
